module.exports = __webpack_public_path__ + "media/marketplace_fund/deck-preview-3-ceb40f12.jpg";